import React from 'react';
import PropTypes from 'prop-types';
import './QuestionnaireNavigationButtons.scss';
function QuestionnaireNavigationButtons(_ref) {
  var activeStep = _ref.activeStep,
    handleNextStep = _ref.handleNextStep,
    handlePreviousStep = _ref.handlePreviousStep,
    workflow = _ref.workflow,
    lastStep = _ref.lastStep,
    position = _ref.position;
  return /*#__PURE__*/React.createElement("div", {
    className: "questionnaire-navigation-buttons ".concat(position)
  }, /*#__PURE__*/React.createElement("div", {
    className: "aside-1 mr-4"
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    id: "".concat(workflow, "-").concat(activeStep.replace(' ', '-'), "-back"),
    className: "btn btn-secondary-dark py-6 px-12",
    onClick: handlePreviousStep
  }, /*#__PURE__*/React.createElement("i", {
    className: "fa fa-chevron-left"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "aside-2"
  }, !lastStep && /*#__PURE__*/React.createElement("button", {
    type: "button",
    id: "".concat(workflow, "-").concat(activeStep.replace(' ', '-')),
    className: "btn btn-primary-darkest",
    onClick: handleNextStep
  }, "Next", ' ', /*#__PURE__*/React.createElement("i", {
    className: "fa fa-chevron-right"
  })), lastStep && /*#__PURE__*/React.createElement("button", {
    type: "button",
    id: "".concat(workflow, "-").concat(activeStep.replace(' ', '-')),
    className: "btn btn-primary-darkest",
    onClick: handleNextStep
  }, "Finish", ' ', /*#__PURE__*/React.createElement("i", {
    className: "fa fa-chevron-right"
  }))));
}
QuestionnaireNavigationButtons.propTypes = {
  activeStep: PropTypes.string.isRequired,
  handleNextStep: PropTypes.func.isRequired,
  handlePreviousStep: PropTypes.func.isRequired,
  workflow: PropTypes.string.isRequired,
  lastStep: PropTypes.bool.isRequired,
  position: PropTypes.string
};
QuestionnaireNavigationButtons.defaultProps = {
  position: ''
};
export default QuestionnaireNavigationButtons;